import React, { useState, useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Button from '../Button';
import Icon from '../Icon';

const DataComponentDisplayControl = ({ data: propData, type, onChange, t }) => {
    const [data] = useState(() => [
        {type: 'table', icon: 'fa-table'},
        ...propData
    ]);

    const onClick = useCallback((button) => {
        const buttonType = button.props['data-type'];

        if (type === buttonType) {
            return;
        }

        onChange && onChange(buttonType);
    }, [type, onChange]);

    return (
        <div className="btn-group m-b">
            {(data || []).map(item => (
                <Button
                    key={item.type}
                    default={true}
                    extraClass={{'active': item.type === type}}
                    text={(<Icon name={item.icon} />)}
                    data-type={item.type}
                    onClick={onClick}
                />
            ))}
        </div>
    );
};

DataComponentDisplayControl.propTypes = {
    data: PropTypes.array,
    type: PropTypes.string,
    onChange: PropTypes.func,
    t: PropTypes.object
};

DataComponentDisplayControl.defaultProps = {
    data: [],
    type: 'table'
};

export default withTranslation(DataComponentDisplayControl);
